import { AxiosResponse } from "axios";
import http from "./httpService";

const error = async (errorMessage: string): Promise<AxiosResponse<void>> => {
  const apiEndpoint = "/log/error";

  return await http.post<void>(`${apiEndpoint}`, errorMessage);
};

export default {
  error,
};
